import dataCollectorWorkModes from '../consts/dataCollector/dataCollectorWorkModes.ts';

export const isGatewayModel = (model) =>
    Boolean(model.chirpStackDeviceProfileId || model.ChirpStackDeviceProfileId || model.chirpStackDeviceProfileID);

export const extractModelItems = (response) => (Array.isArray(response) ? response : response?.items || []);

export const filterModelsByWorkMode = (items, workMode) => {
    const isGatewayMode = workMode === dataCollectorWorkModes.Gateway;

    return items.filter((model) => isGatewayModel(model) === isGatewayMode);
};
